import { useState, useEffect } from "react";
import Button from "../../Core/Button/Button";
import SelectSearch from "../../Core/Fields/Floating/SelectSearch";
import SelectMultiSearch from "../../Core/Fields/Floating/SelectMultiSearch";
import Date from "../../Core/Fields/Floating/Date";

const CartFilterPopup = ({ 
  show, 
  onClose,
  filters,
  setFilters,
  cardType
}) => {    
  const [localFilters, setLocalFilters] = useState({
    dateFilters: [{label: "From Date", value: ""}, {label: "To Date", value: ""}],
    timeInterval: cardType === 'Sales_Order_to_Bill' || cardType === 'Sales_Order_to_Deliver' ? 'Weekly' : 'Monthly',
    statusFilters: cardType === 'Sales_Order_to_Bill' 
      ? ["To Deliver and Bill", "To Bill", null]
      : cardType === 'Sales_Order_to_Deliver'
      ? ["To Deliver and Bill", "To Deliver", null]
      : []
  });


  const allfilter = [
      { label: "Draft", value: "Draft" },
      { label: "On Hold", value: "On Hold" },
      { label: "To Deliver and Bill", value: "To Deliver and Bill" },
      { label: "To Bill", value: "To Bill" },
      { label: "To Deliver", value: "To Deliver" },
      { label: "Completed", value: "Completed" },
      { label: "Cancelled", value: "Cancelled" },
      { label: "Closed", value: "Closed" }
    ];

  // Status options based on card type
  const statusOptions = {
    'Annual_Sales': [],
    'Active_Customers': [],
    'Sales_Order_to_Bill': allfilter,
    'Sales_Order_to_Deliver': allfilter,
    'Annual_Purchase':allfilter,
    'Purchase_Order_to_Bill':allfilter,
    'Purchase_Orders_to_Receive':allfilter
  };

  // Time interval options
  const timeIntervalOptions = [
    {label: "Daily", value: "Daily"},
    {label: "Weekly", value: "Weekly"},
    {label: "Monthly", value: "Monthly"},
    {label: "Yearly", value: "Yearly"}
  ];

  // Initialize local filters when props change
  useEffect(() => {
    if (show && filters) {
      setLocalFilters({
        dateFilters: filters.dateFilters 
          ? [...filters.dateFilters] 
          : [{label: "From Date", value: ""}, {label: "To Date", value: ""}],
        timeInterval: filters.timeInterval || 
          (cardType === 'Sales_Order_to_Bill' || cardType === 'Sales_Order_to_Deliver' ? 'Weekly' : 'Monthly'),
        statusFilters: filters.statusFilters 
          ? [...filters.statusFilters] 
          : cardType === 'Sales_Order_to_Bill' 
            ? ["To Deliver and Bill", "To Bill", null]
            : cardType === 'Sales_Order_to_Deliver'
            ? ["To Deliver and Bill", "To Deliver", null]
            : []
      });
    }
  }, [show, filters, cardType]);

  const handleDateChange = (index, value) => {
    const updatedDateFilters = [...localFilters.dateFilters];
    updatedDateFilters[index] = {
      ...updatedDateFilters[index],
      value
    };
    setLocalFilters(prev => ({
      ...prev,
      dateFilters: updatedDateFilters
    }));
  };

  const handleTimeIntervalChange = (value) => {
    setLocalFilters(prev => ({
      ...prev,
      timeInterval: value
    }));
  };

  const handleStatusChange = (values) => {
    setLocalFilters(prev => ({
      ...prev,
      statusFilters: values
    }));
  };

  const handleApply = () => {
    // Ensure we're passing a complete filters object
    const completeFilters = {
      dateFilters: localFilters.dateFilters,
      timeInterval: localFilters.timeInterval,
      statusFilters: localFilters.statusFilters
    };
    
    setFilters(completeFilters);
    // if (onApplyFilters) {
    //   onApplyFilters();
    // }
    onClose();
  };

  const handleReset = () => {
    const resetFilters = {
      dateFilters: [
        { label: "From Date", value: "" },
        { label: "To Date", value: "" }
      ],
      timeInterval: cardType === 'Sales_Order_to_Bill' || cardType === 'Sales_Order_to_Deliver' 
        ? 'Weekly' 
        : 'Monthly',
      statusFilters: cardType === 'Sales_Order_to_Bill' 
        ? ["To Deliver and Bill", "To Bill", null]
        : cardType === 'Sales_Order_to_Deliver'
        ? ["To Deliver and Bill", "To Deliver", null]
        : []
    };
    setLocalFilters(resetFilters);
  };

  if (!show) return null;
  
  return (
    <div 
      className="modal show d-block" 
      style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}
      onClick={onClose}
    >
      <div 
        className="modal-dialog modal-dialog-centered modal-md"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="modal-content">
          <div className="modal-header py-2">
            <h5 className="modal-title" style={{fontSize:'17.5px'}}>Filter</h5>
            <button 
              type="button" 
              style={{fontSize:'11px'}}
              className="btn-close" 
              onClick={onClose}
            />
          </div>
          
          <div className="modal-body">
            <div className="row mb-3">
              <div className="col-md-6">
                <Date
                  id="fromDate"
                  label="Filter From Date"
                  value={localFilters.dateFilters[0]?.value || ''}
                  onChange={(e) => handleDateChange(0, e.target.value)}
                />
              </div>
              <div className="col-md-6">
                <Date
                  id="toDate"
                  label="Filter To Date"
                  min={localFilters.dateFilters[0]?.value}
                  value={localFilters.dateFilters[1]?.value || ''}
                  onChange={(e) => handleDateChange(1, e.target.value)}
                />
              </div>
            </div>
            
            <div className="row mb-3">
              <div className="col-md-6">
                <SelectSearch
                  list={timeIntervalOptions}
                  label="Time Interval"
                  getOptionLabel={(item) => item.label}
                  getOptionValue={(item) => item.value}
                  value={localFilters.timeInterval}
                  onChange={handleTimeIntervalChange}
                />
              </div>
              {(cardType === 'Sales_Order_to_Bill' || cardType === 'Sales_Order_to_Deliver' || cardType === 'Annual_Purchase' || cardType === 'Purchase_Orders_to_Receive' || cardType === 'Purchase_Order_to_Bill') && (
                <div className="col-md-6">
                  <SelectMultiSearch
                    label="Status"
                    options={statusOptions[cardType]}
                    value={localFilters.statusFilters}
                    onChange={handleStatusChange}
                  />
                </div>
              )}
            </div>
          </div>
          
          <div className="modal-footer">

             <Button
                className="custom-btn-9898970"
                onClick={handleReset}
                // disabled={isLoading || (!file && apiData.length === 0 && invalidItems.length === 0)}
              >
                Reset
              </Button>
              
                <Button
                  className="custom-btn-00989"
                  onClick={handleApply}
                >
                 Apply
                </Button>
              
          </div>
        </div>
      </div>
    </div>
  );
};

export default CartFilterPopup;